export type ArtistContextIdFilterState = {
  selectedArtistContextId: number;
};

export const DEFAULT_ARTIST_CONTEXT_ID_VALUE = 0;
